// const isDevelopment = process.env.DEV

export default {
  authServerEndpoint:
    process.env.VUE_APP_SERVER_ENDPOINT || 'http://localhost:8000/', // Should end with a slash
  redirectUrl: process.env.VUE_APP_REDIRECT_URL || 'http://one.vue.co.ke:8080',
  clientId: process.env.VUE_APP_ONE_CLIENT_ID || '60d9c872dde657da5f2ff37c',
  clientSecret: process.env.VUE_APP_ONE_CLIENT_SECRET || '',
}
